import axios from 'axios'
import { BASE_URL } from './constant'

// eslint-disable-next-line import/prefer-default-export
export const axiosInst = axios.create({
  baseURL: BASE_URL,

  // timeout: 1000,
  headers: {
    // 'Accept': 'application/vnd.GitHub.v3+json',
    // 'Authorization': 'token <your-token-here> -- https://docs.GitHub.com/en/authentication/keeping-your-account-and-data-secure/creating-a-personal-access-token'
    'Content-Type': 'application/json',
  },
})
